const getPaymentTerms = async () => {
  const productCardPaymentTermsContainers = document.querySelectorAll('[data-product-payment-terms]');

  if (productCardPaymentTermsContainers.length === 0) return;

  const getProductDOM = async (link) => {
    try {
      const response = await fetch(link);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const paymentTermsBlock = doc.querySelector(".selluxe-payment-terms");

      return paymentTermsBlock ? paymentTermsBlock.outerHTML : null;
    } catch (error) {
      console.error("Error fetching page:", error);
      return null;
    }
  };

  const popupFunction = (container) => {
    console.log('popupfunction');
    const body = document.querySelector('body');
    
    const idealTrigger = container.querySelector('.ideal-payment-terms.popup-trigger .trigger-btn');
    const idealPopup = container.querySelector('.ideal-payment-terms.popup');
    const idealPopupClose = idealPopup.querySelectorAll('.popup-close');

    if(!idealPopup && idealTrigger && idealPopupClose.length === 0) return;

    idealTrigger.addEventListener('click', () => {
      idealPopup.style.display = 'flex';
    });

    idealPopupClose.forEach(btn => {
      btn.addEventListener('click', () => {
        idealPopup.style.display = 'none';
      });
    });

    body.appendChild(idealPopup);

    const spraypayTrigger = container.querySelector('.spraypay-payment-terms.popup-trigger .trigger-btn');
    const spraypayPopup = container.querySelector('.spraypay-payment-terms.popup');
    const spraypayPopupClose = spraypayPopup.querySelectorAll('.popup-close');
    const sprayPayInstallmentBtns = spraypayPopup.querySelectorAll('.installment-btn');
    const installmentDisplay = spraypayPopup.querySelector('.installment-amount-detail');

    if(!spraypayPopup && spraypayTrigger && spraypayPopupClose.length === 0) return;

    spraypayTrigger.addEventListener('click', () => {
      spraypayPopup.style.display = 'flex';
    });

    spraypayPopupClose.forEach(btn => {
      btn.addEventListener('click', () => {
        spraypayPopup.style.display = 'none';
      });
    });

    sprayPayInstallmentBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        installmentDisplay.innerText = `Je betaald ${btn.dataset.value} per maand`;
      });
    });

    body.appendChild(spraypayPopup);
  }

  productCardPaymentTermsContainers.forEach(async (container) => {
    const link = container.dataset.productLink;
    const paymentTermHtml = await getProductDOM(link);

    if (!paymentTermHtml) return;

    container.innerHTML = paymentTermHtml;

    const scripts = container.querySelectorAll("script");
    scripts.forEach((script) => {
      script.remove();
    });

    popupFunction(container);
  });
};

window.addEventListener("DOMContentLoaded", getPaymentTerms);